import ErrorComponent from "@/components/empty/ErrorComponent";
import { TermsT } from "@/types/horseRacing";
import styles from "./termList.module.scss";

interface TermResultsProps {
  currentTerms: TermsT;
}

const TermResults = ({ currentTerms }: TermResultsProps) => {
  const orderedTerms = currentTerms.sort((a, b) =>
    a.term.localeCompare(b.term)
  );
  return (
    <ul>
      {orderedTerms.map((termData) => {
        if (termData.enabled) {
          return (
            <li className={styles.termItem} key={termData.description}>
              <p className={styles.term}>{termData.term}</p>
              <p className={styles.description}>{termData.description}</p>
            </li>
          );
        }
        return "";
      })}
      {orderedTerms.length === 0 ? (
        <div className={styles.error}>
          <ErrorComponent
            headline="No Terms Available"
            subtext="Please check back later."
            showCta={false}
          />
        </div>
      ) : (
        ""
      )}
    </ul>
  );
};

export default TermResults;
